import { AssetType, OrderType } from './Orders.interfaces';

export const statuses = [
  { label: 'В обработке', value: 'В обработке' },
  { label: 'Ожидает рассмотрения', value: 'Ожидает рассмотрения' },
  { label: 'Исполнена', value: 'Исполнена' },
  { label: 'Отменена', value: 'Отменена' },
  { label: 'Черновик', value: 'Черновик' },
];

export const types = [
  { label: OrderType.SELL, value: OrderType.SELL },
  { label: OrderType.BUY, value: OrderType.BUY },
  { label: OrderType.INCOME, value: OrderType.INCOME },
  { label: OrderType.OUTCOME, value: OrderType.OUTCOME },
];

export const assets = [
  { label: AssetType.VIRTUAL_ASSET, value: AssetType.VIRTUAL_ASSET },
  { label: AssetType.CURRENCY, value: AssetType.CURRENCY },
  { label: AssetType.SHARE, value: AssetType.SHARE },
];
